module.exports = __webpack_public_path__ + "assets/img/AuditCover-w540.2d6dfdc9.webp";